import { ISingleStakeDefinitionList } from '../../entities/IClusterStake';

export const GET_STAKES_DEFINISION_LIST = 'GET_STAKES_DEFINISION_LIST';
export const GET_SINGLE_STAKE_DEFINITION = 'GET_SINGLE_STAKE_DEFINITION';

export interface IStakeTypes {
    GET_STAKES_DEFINISION_LIST: {
        stakesDefinitionList: ISingleStakeDefinitionList[];
    }
}